'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _spauiUtils = require('@tencent/spaui-utils');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _info2 = require('./info');

var _info3 = _interopRequireDefault(_info2);

var _task_component = require('./component/task_component');

var _task_component2 = _interopRequireDefault(_task_component);

var _status_component = require('./component/status_component');

var _status_component2 = _interopRequireDefault(_status_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Tencent is pleased to support the open source community by making SPA UI available.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (C) 2019, a Tencent company. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

/**
 * @fileOverview spaui 任务列表
 * @author kirkzheng
 * @time 2017-12-25
 * @module @tencent/spaui-task
 */

/**
 * @class
 */
var Task = function (_PureComponent) {
    _inherits(Task, _PureComponent);

    function Task() {
        _classCallCheck(this, Task);

        return _possibleConstructorReturn(this, (Task.__proto__ || Object.getPrototypeOf(Task)).apply(this, arguments));
    }

    _createClass(Task, [{
        key: 'isAction',

        /**
         * 组件属性说明
         * @property {titleline} 全局属性
         * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
         * @property {titleline} 基础属性
         * @property {array} data=[]] 任务数据
         * @property {array} done=[]] 已经处理的任务id
         * @property {string|number} [doing=''] 目前正在处理的任务id
         * @property {string|number} [active=''] 目前激活中的任务id
         * @property {func} [onClick] 点击回调
         * @property {func|element} [TaskComponent] 子任务组件结构
         * @property {func|element} [StatusComponent] 状态组件结构
         * @example
         * data = [{
                title: '填写基本信息',                      // 一级任务标题
                list: [{                                   // 子任务
                    href: '#',                             // 任务页面锚点
                    id: 'info_a'                           // 通过id来标识任务，唯一
                    label: '设置权限组的范围和名称1'         // 任务名称
                }, {
                    id: 'info_b'
                    label: '设置权限组的范围和名称2'
                }]
            }, {
                title: '设置关注人',
                list: [{
                    href: '#',
                    id: 'guanzhuren_a'
                    label: '设置该权限组下的关注人'
                }]
            }];
         */
        value: function isAction() {
            var listData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var actionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            var result = false;

            listData.map(function () {
                var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _item$id = item.id,
                    id = _item$id === undefined ? '' : _item$id;

                if (!result && actionId && id === actionId) {
                    result = true;
                }

                return item;
            });

            return result;
        }
    }, {
        key: 'isDone',
        value: function isDone() {
            var listData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var _props$done = this.props.done,
                done = _props$done === undefined ? [] : _props$done;

            var result = true;

            if (listData.length > 0) {
                listData.map(function () {
                    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var id = item.id;

                    if ((0, _spauiUtils.indexOf)(done, id) < 0) {
                        result = false;
                    }
                    return item;
                });
            } else {
                result = false;
            }
            return result;
        }

        // 是否只有一层任务，没有list任务

    }, {
        key: 'isOneLevelData',
        value: function isOneLevelData() {
            var _props$data = this.props.data,
                data = _props$data === undefined ? [] : _props$data;

            var result = true;

            data.map(function () {
                var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                if (item && item.list && item.list.length > 0) {
                    result = false;
                }
                return item;
            });

            return result;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                data = _props.data,
                done = _props.done,
                doing = _props.doing,
                active = _props.active,
                TaskComponent = _props.TaskComponent,
                StatusComponent = _props.StatusComponent,
                _onClick = _props.onClick;


            return _react2.default.createElement(
                'div',
                (0, _spauiUtils.globalProps)(this.props, {
                    className: (0, _classnames2.default)('spaui-task', {
                        'spaui-task-single': this.isOneLevelData()
                    })
                }, Task),
                data.map(function () {
                    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var index = arguments[1];
                    var _item$title = item.title,
                        title = _item$title === undefined ? '' : _item$title,
                        _item$list = item.list,
                        list = _item$list === undefined ? [] : _item$list,
                        _item$id2 = item.id,
                        itemId = _item$id2 === undefined ? '' : _item$id2;

                    var isDone = _this2.isDone(list) || (0, _spauiUtils.indexOf)(done, itemId) > -1;
                    var isDoing = (_this2.isAction(list, doing) || itemId === doing) && !isDone;
                    var isActive = _this2.isAction(list, active) || itemId === active;
                    var itemClassName = (0, _classnames2.default)('spaui-task-item', {
                        done: isDone,
                        doing: isDoing,
                        active: isActive || isDoing
                    });

                    return _react2.default.createElement(
                        'div',
                        {
                            className: itemClassName,
                            key: index
                        },
                        _react2.default.createElement(
                            'p',
                            {
                                className: 'spaui-task-title',
                                onClick: function onClick(event) {
                                    return _onClick(event, item);
                                }
                            },
                            title,
                            _react2.default.createElement(StatusComponent, _extends({}, _this2.props, {
                                StatusComponent: null
                            }))
                        ),
                        list.length > 0 ? _react2.default.createElement(
                            'ul',
                            { className: 'spaui-task-list' },
                            list.map(function () {
                                var subItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                var subIndex = arguments[1];
                                var href = subItem.href,
                                    _subItem$label = subItem.label,
                                    label = _subItem$label === undefined ? '' : _subItem$label,
                                    _subItem$id = subItem.id,
                                    id = _subItem$id === undefined ? '' : _subItem$id;

                                var isSubItemDone = (0, _spauiUtils.indexOf)(done, id) > -1;
                                var isSubItemDoing = id === doing && !isSubItemDone;
                                var isSubItemActive = id === active;
                                var statusClassName = (0, _classnames2.default)({
                                    done: isSubItemDone,
                                    doing: isSubItemDoing,
                                    active: isSubItemActive || isSubItemDoing
                                });

                                return _react2.default.createElement(TaskComponent, _extends({}, _this2.props, {
                                    TaskComponent: null,
                                    key: subIndex,
                                    data: subItem,
                                    onClick: function onClick(event) {
                                        return _onClick(event, subItem);
                                    },
                                    href: href,
                                    label: label,
                                    statusClassName: statusClassName
                                }));
                            })
                        ) : null
                    );
                })
            );
        }
    }]);

    return Task;
}(_react.PureComponent);

// 组件标记与上报


Task.propTypes = {
    data: _spauiUtils.PropTypes.array.isRequired,
    done: _spauiUtils.PropTypes.array,
    doing: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.number]),
    active: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.number]),
    onClick: _spauiUtils.PropTypes.func,
    TaskComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
    StatusComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element])
};
Task.defaultProps = {
    data: [],
    done: [],
    doing: '',
    active: '',
    onClick: _spauiUtils.noop,
    TaskComponent: _task_component2.default,
    StatusComponent: _status_component2.default
};
(0, _spauiUtils.setComponentMark)(Task, _info3.default, function () {
    (0, _spauiUtils.reportComponentUsage)(_extends({
        scope: 'spaui'
    }, _info3.default));
});

exports.default = Task;